<template>
  <div>
    <div class="breadcrumb">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/' }">
          <i class="el-icon-s-home"></i>
        </el-breadcrumb-item>
        <el-breadcrumb-item>{{
          getTitle('header.dynamic')
        }}</el-breadcrumb-item>
        <el-breadcrumb-item>{{ breadcrumbTitle() }}</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <div class="news-wrapper">
      <ul class="news-list clearfix">
        <li
          v-for="item in newsList"
          :key="item.news_id"
          @click="goNewsInfo(item.news_id)"
        >
          <div class="news-list-item">
            <img v-if="item.news_image" :src="item.news_image" />
            <div class="text">
              <h3>{{ item.news_title }}</h3>
              <p class="date">{{ item.created_at }}</p>
              <p>{{ item.news_desc }}</p>
            </div>
          </div>
        </li>
      </ul>
      <el-pagination
        v-if="newsList && newsList.length > 0"
        background
        layout="prev, pager, next"
        :page-count="pageAll"
        :current-page="current_page"
        @current-change="currentChange"
      >
      </el-pagination>
      <div class="news-list-none" v-if="newsList.length == 0">
        <p>{{ getTitle('content.noData') }}</p>
      </div>
    </div>
  </div>
</template>

<script>
import { setLocaleToPath, loadLanguageAsync } from '@/setup/i18n';
import www from '@/api/www';
import _ from 'underscore';
import routerTo from '@/router/routerTo';
export default {
  data() {
    return {
      newsList: [],
      page: 1,
      pageAll: 0,
      current_page: 1,
    };
  },
  computed: {
    locale() {
      return this.$store.state.locale;
    },
    category() {
      return this.$store.state.category;
    },
  },
  watch: {
    $route(to, from) {
      // console.log(to, from);
      if (to.fullPath !== from.fullPath) {
        // this.category = to.query.category;
        this.page = 1;
        this.getNewsList(this.locale);
      }
    },
  },
  created() {
    this.$store.commit('setLocale', this.$i18n.locale); // 触发指定默认语言
    // this.category = this.$route.query.category;
    this.getNewsList(this.locale);
  },
  methods: {
    currentChange(value) {
      // console.log('page是', value);
      this.page = value;
      this.getNewsList(this.locale);
    },
    getTitle(name) {
      loadLanguageAsync(this.locale);
      return this.$t(`${name}.title`);
    },
    breadcrumbTitle() {
      if (this.category == '1') {
        return this.getTitle('header.notice');
      } else if (this.category == '2') {
        return this.getTitle('header.recentDynamic');
      } else if (this.category == '3') {
        return this.getTitle('header.news');
      }
    },
    async getNewsList(languageStr) {
      // console.log('languageStr: ', languageStr);
      this.newsList = [];
      const getNewsList = await www.getNewsList({
        merchant_code: process.env.VUE_APP_MERCHANT_CODE,
        status: 'publish',
        category: this.category,
        language: languageStr == 'zh-cmn-Hans' ? 'zh' : languageStr,
        page: this.page,
        page_size: 10,
      });
      this.newsList = getNewsList.data;
      let orderNumberTotal = getNewsList.total;
      this.pageAll = getNewsList.page_total; //Math.ceil(orderNumberTotal / 2);
      this.current_page = getNewsList.current_page;
      // console.log('123456', this.pageAll);
    },
    goNewsInfo(ID) {
      routerTo.toNewsInfo(this.$router, false, {
        category: this.category,
        ID: ID,
      });
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less">
.news-wrapper {
  width: 1100px;
  margin: 0 auto;
  .news-list {
    margin-top: 20px;
    text-align: left;
    list-style: none;
    li {
      margin-bottom: 20px;
      padding: 20px 30px;
      border-radius: 10px;
      background: #fff;
      cursor: pointer;
      .news-list-item {
        display: flex;
        img {
          width: 200px;
          height: 140px;
          margin-right: 30px;
          border-radius: 10px;
        }
        .text {
          padding: 10px 0;
          h3 {
            margin: 0px 0 10px;
            color: #191b26;
            font-weight: normal;
            font-size: 22px;
            line-height: 32px;
          }
          .date {
            margin-bottom: 10px;
            color: #31a775;
          }
          p {
            color: #515457;
          }
        }
      }
    }
    li:hover {
      box-shadow: 0 2px 16px 0 rgba(0, 0, 0, 0.1);
    }
  }
  .el-pagination {
    margin: 40px 0 60px;
    text-align: center;
  }
  .news-list-none {
    padding: 40px 0;
    text-align: center;
  }
}
/deep/ .el-pagination.is-background .el-pager li:not(.disabled).active {
  background-color: #31a775;
}
</style>
